<template>
    <component :is="currentComponent" />
</template>

<script>
import XiHome from '@/components/showcase/home/XiHome'
import KocomHome from '@/components/showcase/home/KocomHome'
import SoldocHome from '@/components/showcase/home/SoldocHome'

export default {
    name: 'home',
    components: {
        XiHome,
        KocomHome,
        SoldocHome
    },
    computed: {
        currentComponent: function() {
            const componentMap = {
                xi: 'XiHome',
                kocom: 'KocomHome',
                soldoc: 'SoldocHome'
            }
            return componentMap[this.$route.params.showcase] || 'XiHome'
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/showcase/Home.vue